import { Link } from "react-router-dom";
import { useT, useLang } from "../../i18n";

export const Credentials = () => {
  const t = useT();
  const lang = useLang();
  return (
    <section
      className="sp-section sp-section--alt"
      data-testid="section-credentials"
    >
      <div className="sp-container">
        <div className="sp-reveal">
          <span className="sp-eyebrow">{t.credentials.eyebrow}</span>
          <h2 className="sp-title">
            {t.credentials.titleLine1}
            <br />
            {t.credentials.titleLine2}
          </h2>
          <p className="sp-lead">{t.credentials.lead}</p>
        </div>
        <div className="sp-cred-row sp-reveal">
          {t.credentials.items.map((c) => (
            <div className="sp-cred-item" key={c.title}>
              <h4>{c.title}</h4>
              <p>{c.body}</p>
            </div>
          ))}
        </div>
        <div className="sp-cred-readmore sp-reveal">
          <Link
            to={lang === "en" ? "/about" : "/es/about"}
            className="sp-btn sp-btn-ghost"
            data-testid="credentials-read-more"
          >
            {t.credentials.readMore} <span className="arrow">→</span>
          </Link>
        </div>
      </div>
    </section>
  );
};
